var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 6C2 5.44772 2.44772 5 3 5H11C14.4608 5 17.1952 5.81597 19.0902 7.25169C21.0072 8.70418 22 10.7473 22 13C22 13.5523 21.5523 14 21 14C20.4477 14 20 13.5523 20 13C20 11.3827 19.3078 9.92582 17.8823 8.84581C16.4348 7.74903 14.1692 7 11 7H3C2.44772 7 2 6.55228 2 6Z",
    fill: "#17BE17"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 12C21.5523 12 22 12.4477 22 13C22 13.7957 21.6839 14.5587 21.1213 15.1213C20.5587 15.6839 19.7957 16 19 16H3C2.44772 16 2 15.5523 2 15C2 14.4477 2.44772 14 3 14H19C19.2652 14 19.5196 13.8946 19.7071 13.7071C19.8946 13.5196 20 13.2652 20 13C20 12.4477 20.4477 12 21 12Z",
    fill: "#17BE17"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 5C3.55228 5 4 5.44772 4 6V10H20.5C21.0523 10 21.5 10.4477 21.5 11C21.5 11.5523 21.0523 12 20.5 12H3C2.44772 12 2 11.5523 2 11V6C2 5.44772 2.44772 5 3 5Z",
    fill: "#17BE17"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 9C3.55228 9 4 9.44772 4 10V14C4 14.5523 3.55228 15 3 15C2.44772 15 2 14.5523 2 14V10C2 9.44772 2.44772 9 3 9Z",
    fill: "#17BE17"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 5C8.55228 5 9 5.44772 9 6V11C9 11.5523 8.55228 12 8 12C7.44772 12 7 11.5523 7 11V6C7 5.44772 7.44772 5 8 5Z",
    fill: "#17BE17"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 5.5C13.5523 5.5 14 5.94772 14 6.5V11C14 11.5523 13.5523 12 13 12C12.4477 12 12 11.5523 12 11V6.5C12 5.94772 12.4477 5.5 13 5.5Z",
    fill: "#17BE17"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 19C2 18.4477 2.44772 18 3 18H21C21.5523 18 22 18.4477 22 19C22 19.5523 21.5523 20 21 20H3C2.44772 20 2 19.5523 2 19Z",
    fill: "#17BE17"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrain);
export default __webpack_public_path__ + "static/media/train.5e4795e9a0162a2b66af8d3ef0d60ccb.svg";
export { ForwardRef as ReactComponent };